import { useEffect, useState } from "react";
import { Card, CardContent, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import BasicLayout from "layouts/authentication/components/BasicLayout";
import StorageManager from "helpers/StorageManager";
import image1 from "assets/images/prichard/bg_1.webp";
import image2 from "assets/images/prichard/bg_2.webp";
import image3 from "assets/images/prichard/bg_3.webp";
import brandWhite from "assets/images/logo-without-modules.png";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const images = [image1, image2, image3];

const gridSize = {
  xs: 12,
  sm: 10,
  md: 8,
  lg: 6,
  xl: 5,
};

const getBackgroundIndex = () => {
  const storageBackgroundIndex = parseInt(StorageManager.get("CLOCKIN_BG_INDEX"), 10);
  if (Number.isNaN(storageBackgroundIndex)) {
    return 0;
  }
  if (storageBackgroundIndex < 0 && storageBackgroundIndex > 2) {
    return 0;
  }
  return storageBackgroundIndex;
};

const useBackgroundIndex = () => {
  const [backgroundIndex] = useState(getBackgroundIndex());

  useEffect(() => {
    const newBackgroundIndex = backgroundIndex === 2 ? 1 : backgroundIndex + 1;
    StorageManager.set("CLOCKIN_BG_INDEX", newBackgroundIndex);
  }, [backgroundIndex]);

  return getBackgroundIndex();
};

const Style = styled.div`
  .icon {
    color: white;
    background: #2595d1;
    border-radius: 50%;
    font-weight: bold;
    font-size: 80px !important;
    padding: 6px;
    height: auto;
    width: auto;
  }

  .current-time {
    text-align: center;
  }

  .end-clock-message {
    font-size: 16px;

    .end-clock-status {
      color: #00a7e2;
      text-transform: uppercase;
      font-weight: bold;
    }
  }

  .ok-button {
    background-color: #00a7e2;
    width: 50%;
    min-wdith: 200px;
    max-wdith: 80%;
  }

  .clock-button {
    background-color: #00a7e2;
    width: 200px;
  }

  .clock-info {
    text-align: center;

    .MuiTypography-root,
    .clock-info_clock {
      font-size: 17px;
    }

    .clock-info_clock {
      color: #00a7e2;
      font-weight: bold;
    }

    .clock-info_dot {
      margin: 0px auto;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #ed1b24;
    }

    .clock-info_dot-text {
      color: #ed1b24;
      font-weight: bold;
    }

    &.clocked {
      .clock-info_dot {
        background: #0ed145;
      }
      .clock-info_dot-text {
        color: #0ed145;
      }
    }
  }

  .log-out-button {
    border-radius: 0;
    border-top-right-radius: 0.6rem;
  }
`;
function ThankYou() {
  const { t } = useTranslation();
  const backgroundIndex = useBackgroundIndex();

  return (
    <BasicLayout image={images[backgroundIndex]} gridSize={gridSize}>
      <Style>
        <Card>
          <CardContent>
            <MDBox mb={3}>
              <Grid container justifyContent="center">
                <Grid item>
                  <img height={70} src={brandWhite} alt="logo" />
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mb={3}>
              <Grid container justifyContent="center">
                <Grid item>
                  <MDTypography style={{ fontSize: 17, textAlign: "center" }}>
                    {t("Thank you for using Simplitime")}
                  </MDTypography>
                </Grid>
              </Grid>
            </MDBox>
          </CardContent>
        </Card>
      </Style>
    </BasicLayout>
  );
}

export default ThankYou;
